import React from 'react';
import { ImageTypeEnum } from 'api';
import { observer } from 'mobx-react';
import useStyles from './ImagesGallery.styles';
import Typography from '@material-ui/core/Typography';
import { ImagePreview } from './components/ImagePreview';
import { CreativeImage } from '../../../../../../types';
import { useImagePreview } from '../../hooks/useImagePreview';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { ImageWithDifferentRatios } from './components/ImageWithDifferentRatios/';
import { Card, CardActions, CardMedia, Button } from '@material-ui/core';
import { useImagesWithDifferentRatios } from '../../hooks/useImagesWithDifferentRatios';

interface Props {
  data: CreativeImage[];
  imageType: ImageTypeEnum;
}

export const ImagesGallery: React.FC<Props> = observer(({ data = [], imageType }: Props) => {
  const classes = useStyles();

  const { handleCloseImagePreview, openImagePreview, handleOpenImagePreview } = useImagePreview();
  const { openRatiosDialog, handleOpenRatiosDialog, handleCloseRatiosDialog } = useImagesWithDifferentRatios();

  return (
    <div className={classes.root}>
      {data.length ? (
        data
          .filter(({ type }) => type === imageType)
          .map((image, index) => (
            <LazyLoadComponent key={index}>
              <Card className={classes.imageCard}>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    style={{ marginLeft: 'auto' }}
                    onClick={() => handleOpenImagePreview(image.url)}
                  >
                    preview
                  </Button>
                </CardActions>
                <CardMedia
                  component="img"
                  image={image.url ?? ''}
                  alt="keywee-creative-image"
                  onClick={() => handleOpenRatiosDialog(image.url)}
                />
              </Card>
            </LazyLoadComponent>
          ))
      ) : (
        <Typography>No images to show !</Typography>
      )}

      {openImagePreview && (
        <ImagePreview open={openImagePreview.show} url={openImagePreview.url} onClose={handleCloseImagePreview} />
      )}

      {openRatiosDialog.show && (
        <ImageWithDifferentRatios
          open={openRatiosDialog.show}
          url={openRatiosDialog.url}
          handleClose={handleCloseRatiosDialog}
        />
      )}
    </div>
  );
});
